import makeTable from "./makeTable";
import BASE_WIDTH_COLUMNS from "./constants/baseWidthColumns";

const { DATE, NOTES } = BASE_WIDTH_COLUMNS;

export enum ColumnId {
	FullName = "fullName",
	Alias = "alias",
	ParkNumber = "parkNumber",
	TaxId = "taxId",
	Phones = "phones",
	Balance = "balance",
	BonusBalance = "bonusBalance",
	Role = "role",
	ExecutorTeamId = "executorTeamId",
	Company = "company",
	TaxiService = "taxiService",
	RegisteredAt = "registeredAt",
	ResponsibleDispatcher = "responsibleDispatcher",
	ExecutorRateId = "executorRateId",
	Priority = "priority",
	ElectronicReceipts = "electronicReceipts",
	Notes = "notes",
}

export const translationTablePath = "mainPage.accounts.executors.columns.";

const accountsExecutors = makeTable({
	allIds: [
		ColumnId.FullName,
		ColumnId.Alias,
		ColumnId.ParkNumber,
		ColumnId.TaxId,
		ColumnId.Phones,
		ColumnId.Balance,
		ColumnId.BonusBalance,
		ColumnId.Role,
		ColumnId.ExecutorTeamId,
		ColumnId.Company,
		ColumnId.TaxiService,
		ColumnId.RegisteredAt,
		ColumnId.ResponsibleDispatcher,
		ColumnId.ExecutorRateId,
		ColumnId.Priority,
		ColumnId.ElectronicReceipts,
		ColumnId.Notes,
	],
	i18tPath: (id) => `${translationTablePath}${id}`,
	defaultIds: [
		ColumnId.FullName,
		ColumnId.Alias,
		ColumnId.ParkNumber,
		ColumnId.TaxId,
		ColumnId.Phones,
		ColumnId.Balance,
		ColumnId.BonusBalance,
		ColumnId.Role,
		ColumnId.ExecutorTeamId,
		ColumnId.Company,
		ColumnId.TaxiService,
		ColumnId.RegisteredAt,
		ColumnId.ResponsibleDispatcher,
		ColumnId.ExecutorRateId,
		ColumnId.Priority,
		ColumnId.ElectronicReceipts,
		ColumnId.Notes,
	],
	initialSortMethod: {
		column: ColumnId.Alias,
		type: "asc",
	},
	initialWidths: {
		[ColumnId.FullName]: 137,
		[ColumnId.Alias]: 100,
		[ColumnId.ParkNumber]: 100,
		[ColumnId.TaxId]: 120,
		[ColumnId.Phones]: 150,
		[ColumnId.Balance]: 110,
		[ColumnId.BonusBalance]: 130,
		[ColumnId.Role]: 140,
		[ColumnId.ExecutorTeamId]: 140,
		[ColumnId.Company]: 120,
		[ColumnId.TaxiService]: 120,
		[ColumnId.RegisteredAt]: DATE,
		[ColumnId.ResponsibleDispatcher]: 137,
		[ColumnId.ExecutorRateId]: 137,
		[ColumnId.Priority]: 137,
		[ColumnId.ElectronicReceipts]: 180,
		[ColumnId.Notes]: NOTES,
	},
	initialResizable: {
		[ColumnId.FullName]: true,
		[ColumnId.Alias]: true,
		[ColumnId.ParkNumber]: true,
		[ColumnId.TaxId]: true,
		[ColumnId.Phones]: true,
		[ColumnId.Balance]: true,
		[ColumnId.BonusBalance]: true,
		[ColumnId.Role]: true,
		[ColumnId.ExecutorTeamId]: true,
		[ColumnId.Company]: true,
		[ColumnId.TaxiService]: true,
		[ColumnId.RegisteredAt]: true,
		[ColumnId.ResponsibleDispatcher]: true,
		[ColumnId.ExecutorRateId]: true,
		[ColumnId.Priority]: true,
		[ColumnId.ElectronicReceipts]: true,
		[ColumnId.Notes]: true,
	},
	initialSortable: {
		[ColumnId.FullName]: true,
		[ColumnId.Alias]: true,
		[ColumnId.ParkNumber]: true,
		[ColumnId.TaxId]: true,
		[ColumnId.Phones]: true,
		[ColumnId.Balance]: true,
		[ColumnId.BonusBalance]: true,
		[ColumnId.Role]: true,
		[ColumnId.ExecutorTeamId]: true,
		[ColumnId.Company]: true,
		[ColumnId.TaxiService]: true,
		[ColumnId.RegisteredAt]: true,
		[ColumnId.ResponsibleDispatcher]: true,
		[ColumnId.ExecutorRateId]: true,
		[ColumnId.Priority]: true,
		[ColumnId.ElectronicReceipts]: true,
		[ColumnId.Notes]: true,
	},
});

export default accountsExecutors;
